import { render } from "./InspeccionVehicular.vue?vue&type=template&id=f5d23c92&scoped=true"
import script from "./InspeccionVehicular.vue?vue&type=script&lang=js"
export * from "./InspeccionVehicular.vue?vue&type=script&lang=js"

import "./InspeccionVehicular.vue?vue&type=style&index=0&id=f5d23c92&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d23c92"]])

export default __exports__